import React, { FC, useState } from "react";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { IInput } from "types/interfaces";
import axios from "axios";
import { RentripsURL } from "utils/request";

export interface PageForgetProps {
  className?: string;
}

const PageForgetPass: FC<PageForgetProps> = ({ className = "" }) => {
  const [email, setEmail] = useState<IInput>({ value: "", warning: "" });
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);

  const postForgetEmail = async (email: String) => {
    const { data } = await axios.post(RentripsURL +"/api/user/password", { email });
    if (data) {
      setLoading(false);
      setSuccess(data.success);
    }
  };

  const handleForgetPass = (e: React.FormEvent<HTMLFormElement>): void => {
    setLoading(true);

    postForgetEmail(email.value);
    e.preventDefault();
  };

  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>Lupa Password</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Reset Password
        </h2>

        <div className="max-w-md mx-auto space-y-6">
          {/* FORM */}
          <form className="grid grid-cols-1 gap-6" onSubmit={handleForgetPass}>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">
                Email
              </span>
              <Input
                type="email"
                placeholder="contoh@email.com"
                className="mt-1"
                value={email.value}
                onChange={(e) =>
                  setEmail({ value: e.target.value, warning: "" })
                }
              />
              {email.warning && (
                <span className="text-red-600 text-sm">{email.warning}</span>
              )}
            </label>
            <ButtonPrimary
              type="submit"
              loading={loading}
              className={`${success && "bg-green-400 dark:bg-green-500"}`}
            >
              {success ? "Silahkan cek emailmu" : "Berikutnya"}
            </ButtonPrimary>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PageForgetPass;
